import React from 'react';
import { Button, makeStyles, Typography, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15%',
  },
  textSpacing: {
    paddingBottom: '1.5rem',
  },
  email: {
    color: '#323232',
  },
}));

export const Error: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const history = useHistory();
  return (
    <div className={classes.container}>
      <Typography variant={'h4'} className={classes.textSpacing}>
        Error
      </Typography>
      <Typography className={classes.textSpacing}>
        Digital Orders is experiencing an error, click the link below to try again
      </Typography>
      <Button
        data-test-id="login-button"
        onClick={() => history.push('/login')}
        variant="contained"
        color="primary"
      >
        Go to Login
      </Button>
    </div>
  );
};
